/**
 * @module constants/sessionStorage
 *
 * session storage keys
 */

/**
 * Root namespace key for Origin sales related details
 * @type {string}
 */
export const ORIGIN_SALES_DETAIL = 'OriginSalesDetails';

/**
 * Details of the user selected plan. This will be used to diff the revalidate plan from combine sales form
 * @type {string}
 */
export const SELECTED_PLAN = 'selectedPlan';
